var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconPipe = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.0002 31.7143C24.4736 31.7143 24.8574 31.3305 24.8574 30.8571V17.1429C24.859 16.9194 24.7703 16.7051 24.6113 16.5481C24.4526 16.3799 24.2312 16.2849 24.0002 16.2857C23.5269 16.2857 23.1431 16.6695 23.1431 17.1429V30.8571C23.1431 31.3305 23.5269 31.7143 24.0002 31.7143Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8569 39.4286H42.8569V48H30.8569V39.4286Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.857 34.2857V27.4286C42.8507 22.2238 38.6332 18.0063 33.4284 18H26.5713V30H28.2856C29.7056 30 30.857 31.1514 30.857 32.5714V34.2857H42.857Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M44.3092 37.4674C44.4771 37.3087 44.5721 37.0882 44.5717 36.8571C44.5717 36.3838 44.1879 36 43.7145 36H30.0002C29.5269 36 29.1431 36.3838 29.1431 36.8571C29.1431 37.3305 29.5269 37.7143 30.0002 37.7143H43.7145C43.938 37.7164 44.1531 37.6272 44.3092 37.4674Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5716 30H21.4288V18H19.7145C18.2944 18 17.1431 16.8486 17.1431 15.4286V13.7143H5.14307V20.5714C5.14934 25.7762 9.36684 29.9937 14.5716 30Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0001 12C18.4735 12 18.8573 11.6162 18.8573 11.1429C18.8573 10.6695 18.4735 10.2857 18.0001 10.2857H4.28586C4.06236 10.2832 3.84766 10.3724 3.69197 10.5327C3.52372 10.6909 3.42829 10.9118 3.42871 11.1429C3.42871 11.6162 3.8125 12 4.28586 12H18.0001Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.14307 0H17.1431V8.57143H5.14307V0Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPipe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_pipe.09b5eb8c.svg";
export { ForwardRef as ReactComponent };